export type NavOpenDetector = {
  click: () => void;
  dispose: () => void;
  enter: () => void;
  hide: () => void;
  leave: () => void;
};

const OPEN_DELAY_MS = 250;

export const createNavOpenDetector = (onOpen: () => void, closeDelayMs: number): NavOpenDetector => {
  let closeDelayTimer: ReturnType<typeof setTimeout> | undefined;
  let openDelayTimer: ReturnType<typeof setTimeout> | undefined;
  let hasOpened = false;

  const open = () => {
    clearTimeout(openDelayTimer);

    if (!hasOpened) {
      hasOpened = true;
      onOpen();
    }
  };

  const end = () => {
    clearTimeout(closeDelayTimer);
    clearTimeout(openDelayTimer);
    hasOpened = false;
  };

  return {
    click: open,
    dispose: end,
    enter: () => {
      clearTimeout(closeDelayTimer);
      clearTimeout(openDelayTimer);

      if (!hasOpened) {
        openDelayTimer = setTimeout(open, OPEN_DELAY_MS);
      }
    },
    hide: end,
    leave: () => {
      clearTimeout(openDelayTimer);
      closeDelayTimer = setTimeout(end, closeDelayMs);
    },
  };
};
